module.exports = __webpack_public_path__ + "static/media/network.29e389db.svg";